/*Auto-generated at pre-build.js*/ export class BuildDetails { public static readonly isoDate = '2026-10-26T09:08:09.370Z'; }